<script setup lang="ts">
import { ref } from 'vue'

interface Props {
  modelValue: boolean
  title?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  closeOnOutsideClick?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  title: '',
  size: 'md',
  closeOnOutsideClick: true,
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const handleClose = () => {
  emit('update:modelValue', false)
}

const handleBackdropClick = (event: Event) => {
  if (event.target === event.currentTarget && props.closeOnOutsideClick) {
    handleClose()
  }
}

const sizeClasses = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
}
</script>

<template>
  <div
    v-if="modelValue"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    @click="handleBackdropClick"
  >
    <div :class="['bg-white rounded-lg shadow-xl p-6', sizeClasses[size]]">
      <div class="mb-4">
        <slot />
      </div>
    </div>
  </div>
</template>
